import * as tslib_1 from "tslib";
import { m } from '../../hyperscript';
import { View } from '../view';
import { EventManager } from './eventmanager';
import { MapsContext } from './maps';
var Marker = /** @class */ (function (_super) {
    tslib_1.__extends(Marker, _super);
    function Marker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Marker.prototype.onRemove = function () {
        if (this.marker)
            this.marker.setMap(null);
    };
    Marker.prototype.render = function () {
        var _this = this;
        var _a = this.attrs, children = _a.children, on = _a.on, options = tslib_1.__rest(_a, ["children", "on"]);
        return m(MapsContext.Consumer, function (map) {
            if (!map)
                throw 'No Maps parent detected';
            if (_this.marker)
                _this.marker.setOptions(options);
            else
                _this.marker = new google.maps.Marker(tslib_1.__assign({ map: map }, options));
            return m(EventManager, {
                on: on,
                object: _this.marker
            }, _this.children);
        });
    };
    return Marker;
}(View));
export { Marker };
